import { DEFAULT_COLORS } from "../../colors";
import { ID_NAMES } from "../../env";

const jumpingDots = () => {

    const { messagesFontColor } = DEFAULT_COLORS;

    const dots = document.createElement("div");
    dots.classList.add(ID_NAMES.JUMPING_DOTS);

    [...Array(3).keys()].forEach(x => {

        const dot = document.createElement("div");
        dot.classList.add('chatheadJumpingDot');
        dot.style.backgroundColor = messagesFontColor;

        dots.append(dot)
    })

    return dots

}

export default jumpingDots